export type FunderRatingEvidenceKind =
  | "note-and-mvf"
  | "note-only"
  | "mvf-only";

export function isFunderRatingEvaluationActive(
  state: string | null | undefined,
): boolean {
  return state !== "canceled" && state !== "deferred" && state !== "recused";
}

/**
 * The shared membership rule for funder evaluation ratings. A manual funder
 * score does not create an evaluation: the recommender must have left a note,
 * an MVF, or both.
 */
export function classifyFunderRatingEvidence({
  hasNote,
  hasMvf,
}: {
  hasNote: boolean;
  hasMvf: boolean;
}): FunderRatingEvidenceKind | null {
  if (hasNote && hasMvf) {
    return "note-and-mvf";
  }

  if (hasNote) {
    return "note-only";
  }

  if (hasMvf) {
    return "mvf-only";
  }

  return null;
}
